import { MutationTree } from 'vuex';

import type {Product, PagerData, ProductData} from '@/types';

import { State } from './state';
import { ProductMutationTypes as MutationTypes } from './mutation-types';

export type Mutations<S = State> = {
    [MutationTypes.SET_LOADING_STATUS](state: S): void;
    [MutationTypes.SET_PRODUCTS](state: S, payload: Product[]): void;
    [MutationTypes.APPEND_PRODUCTS](state: S, payload: Product[]): void;
    [MutationTypes.SET_PAGER](state: S, payload: PagerData): void;
}

export const mutations: MutationTree<State> & Mutations = {
    [MutationTypes.SET_LOADING_STATUS](state: State) {
        state.isLoading = !state.isLoading;
    },
    [MutationTypes.SET_PRODUCTS](state: State, newProducts: Product[]) {
        state.items = newProducts;
    },
    [MutationTypes.APPEND_PRODUCTS](state: State, newProducts: Product[]) {
        state.items = [...state.items, ...newProducts];
    },
    [MutationTypes.SET_PAGER](state: State, productData: PagerData) {
        state.pager = productData.pager;
        state.nextPageUrl = productData.nextPageUrl;
        if (productData.nextPageLabel) state.nextPageLabel = productData.nextPageLabel;
        if (productData.backToTopLabel) state.backToTopLabel = productData.backToTopLabel;
    }
};